<template>
  <v-layout row wrap>
    <v-flex xs12 sm5 :class="{ 'mr-5': $vuetify.breakpoint.smAndUp }">
      <date-picker-formatted
        :input-date="inputDate"
        :min-date="minDate"
        label="global.entry.date.label"
        :parking-timezone="parkingTimezone"
        @on-date-selected="onDateSelected"
      ></date-picker-formatted>
    </v-flex>
    <v-flex xs12 sm5 :class="{ 'ml-5': $vuetify.breakpoint.smAndUp }">
      <reservation-time-picker
        :min-date="minDate"
        :input-date="inputDate"
        label="global.entry.time.label"
        :input-time="inputTime"
        :disabled="disabledTime"
        ref="reservationTimePicker"
        :parking-timezone="parkingTimezone"
        @on-time-selected="onTimeSelected"
      >
      </reservation-time-picker>
    </v-flex>
  </v-layout>
</template>

<script>
import DatePickerFormatted from '@/components/commons/DatePickerFormatted';
import ReservationTimePicker from '@/components/commons/ReservationTimePicker';
import moment from 'moment';
import { setTimeout } from 'timers';

export default {
  name: 'ReservationDateTimePicker',
  props: {
    inputTime: {
      type: String,
    },
    inputDate: Date,
    minDate: Date,
    disabledTime: {
      type: Boolean,
      default: false,
    },
    parkingTimezone: {
      type: String,
      default: null,
    },
    subscriptionType: {
      type: String,
      default: null,
    },
  },
  components: {
    [DatePickerFormatted.name]: DatePickerFormatted,
    [ReservationTimePicker.name]: ReservationTimePicker,
  },
  methods: {
    onDateSelected(params) {
      if (typeof this.$refs.reservationTimePicker === 'undefined') {
        setTimeout(() => this.onDateSelected(params), 500);
      } else {
        this.onInnerDateSelected(params);
      }
    },
    onTimeSelected(params) {
      this.$emit('on-time-selected', { timeSelected: params.timeSelected });
    },
    onInnerDateSelected(params) {
      this.$emit('on-date-selected', { date: params.date });

      if (this.subscriptionType !== null && this.subscriptionType === 'NIGHT') {
        return;
      }
      if (moment(this.minDate).startOf('day').isSame(moment(params.date))) {
        this.$refs.reservationTimePicker.setTimeOptionsToday();
      } else {
        this.$refs.reservationTimePicker.setTimeOptions();
      }
    },
    getExternalNearestTime(arg) {
      return this.$refs.reservationTimePicker.getExternalNearestTime(arg);
    },
  },
};
</script>
